export default [
  { path: '/401', component: () => import('@/views/401.vue'), name: 401,meta: {name: '不限制',notMatch: true}},
  { path: '/404', component: () => import('@/views/404.vue'), name: 404,meta: {name: '不限制',notMatch: true}},
  { path: '/500', component: () => import('@/views/500.vue'), name: 500,meta: {name: '不限制',notMatch: true}}
]



// WEBPACK FOOTER //
// ./src/router/error.js